export default {
  ALL: 'all',
  OLD_IMAGES: 'oldImages',
  NEW_IMAGES: 'newImages',
};



// WEBPACK FOOTER //
// ./src/variables/skistarImageStatus.js